import { render, staticRenderFns } from "./VotingIdeasContent.vue?vue&type=template&id=c85a54ca&scoped=true&"
import script from "./VotingIdeasContent.vue?vue&type=script&lang=js&"
export * from "./VotingIdeasContent.vue?vue&type=script&lang=js&"
import style0 from "./VotingIdeasContent.vue?vue&type=style&index=0&id=c85a54ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a54ca",
  null
  
)

export default component.exports